export default function NotificationIcon() {
  return (
    <svg width="14" height="16" viewBox="0 0 14 16">
      <path
        d="M11.0018 5.38251C11.0018 4.34074 10.5879 3.34165 9.85129 2.60501C9.11465 1.86837 8.11555 1.45453 7.07379 1.45453C6.03203 1.45453 5.03293 1.86837 4.29629 2.60501C3.55965 3.34165 3.14581 4.34074 3.14581 5.38251C3.14581 9.96515 1.18182 11.2745 1.18182 11.2745H12.9658C12.9658 11.2745 11.0018 9.96515 11.0018 5.38251Z"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.20642 13.8931C8.09132 14.0915 7.92612 14.2562 7.72735 14.3707C7.52859 14.4852 7.30323 14.5455 7.07385 14.5455C6.84447 14.5455 6.61912 14.4852 6.42035 14.3707C6.22158 14.2562 6.05638 14.0915 5.94128 13.8931"
        stroke="#262626"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
